export default {
  Left: 'Left',
  Right: 'Right',
  Top: 'Top',
  Behind: 'Behind',
  Bottom: 'Bottom',
};
